export default "__VITE_ASSET__Qmdtw5NG__"